import { Chat } from '../../pages';
import { Agent } from '../../pages';
import { Dashboard } from '../../pages';
import { Datasource } from '../../pages';
import { CallManagement } from '../../pages';

export const getRoutes: (meta: AppMetaType) => AppRouteType[] = meta => {
  return [
    {
      icon: 'D',
      url: '/dashboard',
      pageTitle: 'Dashboard',
      menuTitle: 'Dashboard',

      component: Dashboard,
    },

    {
      icon: 'M',
      groupTitle: 'Meeting Assistant',
      action: 'admin',

      routes: [
        {
          action: 'call-manager',
          url: '/call-management',
          component: CallManagement,
          menuTitle: 'Call Management',
        },
      ],
    },

    {
      groupTitle: 'Agents',
      groupUrl: '/agents/:id',
      component: Agent,

      routes: meta.agents.map(agent => ({
        url: `/agents/${agent.id}`,
        menuTitle: agent.name,
      })),
    } as AppRouteGroupType,
    {
      groupTitle: 'Data Sources',
      groupUrl: '/datasources/:id',
      component: Datasource,

      routes: meta.sources.map(s => ({
        menuTitle: s.name,
        url: `/datasources/${s.id}`,
      })),
    } as AppRouteGroupType,
    {
      groupTitle: 'All Chats',
      groupUrl: '/conversations/:id',
      component: Chat,

      routes: meta.conversations.map(c => ({
        url: `/conversations/${c.id}`,
        menuTitle: c.name,
      })),
    } as AppRouteGroupType,
  ];
};
